import React from 'react'

const Error = () => {
  return (
    <div>
      An unexpected error occured
    </div>
  )
}

export default Error
